export default function versionString() {
  return `Versão ${process.env.REACT_APP_VERSION}`;
}
